import React, {useEffect, useState} from "react";
import Dashboard from "./Dashboard";
import MangeDashboard from "./MangeDashboard";
import axios from "axios";
import { useAuthState } from "../../Context/auth-context";
import { toast } from "react-toastify";
import {useMediaQuery} from "beautiful-react-hooks";
import ItemFund from "./ItemFund";



    



export default function Fund() {
    const [balanceCoin,setBalanceCoin] = useState([])
    const [balanceIR,setBalanceIR] = useState({"balance":'',"blocked":''})
    const [isLoading,setIsLoading] = useState(true)
    const [priceCurr,setPriceCurr] = useState({})
    const [PersionNameCoin ,setPersionNameCoin] = useState({})
    const [sums,setSums] = useState({})
    const isSmall = useMediaQuery('(max-width: 768px)')


    let phone = sessionStorage.getItem('user')





    



          async function requestHakdleGetBalance() {
              console.log(phone)
            axios.get('https://api.sinatether.com/Auth/GetBalanceUser/', {
          
            withCredentials:true
        }).then((res) => {
            let b = res.data['userBalance']
            setBalanceCoin(b)
            setBalanceIR(res.data['userIRbalance'])
            console.log(res.data['prices'])
                setPriceCurr(res.data['prices'])
                setPersionNameCoin(res.data['persionName'])
                setSums(res.data['sums'])
            setIsLoading(false)
        }).catch(error=>{
            if (error){
                console.log(error)
                toast.dismiss()
                toast.error("نشست شما منقضی شده است مجددا وارد شوید")
            }
              
        })
          }


          useEffect(async ()=>{


                 const resultInterval = () => {
                         requestHakdleGetBalance()
                         setTimeout(resultInterval, 20000);



                     };
                 resultInterval();




             },[])




    return(
        <MangeDashboard>

            {isSmall ?

            <div className={'body3535'}>


            {isLoading ?
                <div className={'text-center mt-5 pt-5 mb-5 pt-5'}>

                    <i className="fa fa-spinner fa-spin loadIcon"></i>


                </div>
            :
            <>

                <div className={'content3535'}>

                    <div className={'m-card3535'}>

                        <div className={'body-ptt'}>

                            <div className={'tit3535'}>
                                مجموع دارایی(تومان)
                            </div>

                            <div className={'p-css-3535'}>
                                {sums['sum_all'] && new Intl.NumberFormat("fa",{maximumFractionDigits:0}).format(sums['sum_all'])}
                            </div>


                            <div>
                                <div className={'row'}>
                                    <div className={'col-6'}>
                                        <div className={'tit3535 size-min3535'}>
                                        موجودی
                                    </div>

                                    <div className={'r-pp3535'}>
                                    {sums['sum_balance'] && new Intl.NumberFormat("fa",{maximumFractionDigits:0}).format(sums['sum_balance'])}
                                        تومان

                                    </div>
                                    </div>

                                    <div className={'col-6 left-ali'}>
                                            <div className={'tit3535 pl3535'}>
                                        بلوکه شده
                                    </div>

                                    <div className={'r-pp3535 l-pp3535'}>
                                    {sums['sum_blocked'] && new Intl.NumberFormat("fa",{maximumFractionDigits:0}).format(sums['sum_blocked'])}
                                         تومان

                                    </div>

                                    </div>


                                </div>
                            </div>

                        </div>


                    </div>




                </div>



                <div className="sumnadjsnfsf">


                {balanceCoin.map((balance) => (

                    Number(balance['balance']) == 0 && Number(balance['blocked']) == 0 ?
                    <></>

                    :

                        <ItemFund item={balance} names={PersionNameCoin} prices={priceCurr}/>


                    
                
                ))}


                </div>


                </>

            }






            </div>

            :




            <div className={'row fundmain'}>
                <div className={'row w-100 mt-2 pr-2 pl-1   '}>
                        <div className={'ml-2 pl-0'}>

                        <div className={'head_29540 text-large text-center mt-1 pt-1 pb-2   mb-1'}>

                        <div className={'content3535'}>

<div className={'m-card3535'}>

    <div className={'body-ptt'}>

        <div className={'tit3535'}>
            مجموع دارایی(تومان)
        </div>

        <div className={'p-css-3535'}>
            {sums['sum_all'] && new Intl.NumberFormat("fa",{maximumFractionDigits:0}).format(sums['sum_all'])}
        </div>


        <div>
            <div className={'row'}>
                <div className={'col-6 text-center'}>
                    <div className={'tit3535 size-min3535'}>
                    موجودی
                </div>

                <div className={'r-pp3535'}>
                {sums['sum_balance'] && new Intl.NumberFormat("fa",{maximumFractionDigits:0}).format(sums['sum_balance'])}
                    تومان

                </div>
                </div>

                <div className={'col-6 text-center'}>
                        <div className={'tit3535 size-min3535 '}>
                    بلوکه شده
                </div>

                <div className={'r-pp3535 '}>
                {sums['sum_blocked'] && new Intl.NumberFormat("fa",{maximumFractionDigits:0}).format(sums['sum_blocked'])}
                     تومان

                </div>

                </div>


            </div>
        </div>

    </div>


</div>




</div>

                            

                        </div>



                        <div className={' list_fund2020'}>
                            
            <div className={'head_29540 padd-title text-center'}>
                <div className="text-title-report">
                    لیست دارایی

                </div>

            </div>
                            <div className="tableHeader__29540 bt-0">
                                <div className={'col-3 text-normal '}>نام</div>
                                <div className={'col-3 text-normal '}>موجودی</div>
                                <div className={'col-3 text-normal '}>بلوکه شده </div>
                                <div className={'col-3 text-normal pl-0 pr-0 '}>ارزش فعلی (تومان) </div>




                            </div>
                            {isLoading ?
                                <div className={'text-center mt-5 pt-5 mb-5 pt-5'}>

                                    <i className="fa fa-spinner fa-spin loadIcon"></i>


                                </div>
                                :

                                <div className={'listcoinTable '}>
                                    




                                    {balanceCoin.map((balance) => (
                                         Number(balance['balance']) == 0 && Number(balance['blocked']) == 0 ?
                                         <></>
                     
                                         :
                                        <a href={`/${balance['nameCoin']}`} className={'item_ba9887316'}>
                                            <div className={'row itemCoins item2342424dff '} name={'n'}
                                            >
                                                <div className={'col-3'}>
                                                    <img className={'imgcoinlist3536 pr-1'}
                                                         src={`https://static.sinatether.com/CoinsImg/${balance['nameCoin']}.png`}/>
                                                    <span
                                                        className={'text-large  pr-1'}>{PersionNameCoin[balance['nameCoin']]} </span>
                                                    <span
                                                        className={'text-medium text-info'}>{balance['nameCoin']}</span>
                                                </div>
                                                <div className={'col-3 balance_123'}>

                                                        <span
                                                            className={'text-normal line-height-36'}>{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(balance['balance'])}</span>


                                                </div>
                                                <div className={'col-3 balance_123 '}>
                                                        <span className={'text-normal line-height-36 text-danger'}>
                                                            {new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(balance['blocked'])}
                                                        </span>
                                                </div>
                                                <div className={'col-3 pr-0 pl-2'}>
                                                        <span className={'text-normal line-height-36'}>
                                                            { new Intl.NumberFormat("fa",{maximumFractionDigits:0}).format(priceCurr[balance['nameCoin']])}
                                                        </span>
                                                </div>

                                            </div>

                                        </a>

                                    ))}


                                </div>

                            }




                        </div>



                        </div>



                    </div>


            </div>

            }


        </MangeDashboard>
    )

}